import React from 'react';
import { ToastContainer } from 'react-toastify';
import ModalPage from './modal';
import Header from './header.js';
import TopPage from './top.js';
import IntroPage from './intro.js';
import BoardPage from './board.js';
import BadendPage from './badend.js';
import GoodendPage from './goodend.js';
import ResultPage from './result.js';
import NotfoundPage from './notfound.js';
import AlertPage from './alert.js';
import Loading from './loading';
import './main.scss';

class MainPage extends React.Component {
	uid = null;
	data = {};
	messages = [];
	user_name = "";
	api_url = "";
	afterAlert= null;
	afterConfirmYes = null;
	afterConfirmNo = null;
	afterModal = null;
	storage_key = "collie-retro-ink";
	constructor(props){
		super(props);

		this.uid = this.load();
		//console.log("uid:"+uid);
		
		let result_key = null;
		if( this.props.result_key ){
			result_key = this.props.result_key;
		}

		let default_mode = "top";
		if( this.props.result_key ){
			default_mode = "result";
		}

		this.state = {
			play: null,
			level: 0,
			mode: default_mode,
			isLoading: false,
			isOpenAlert: false,
			isConfirm: false,
			isShadow: false,
			alertMessage: "",
			result_key: result_key,
			isOpenModal: false,
			data:[],
			modal_page: "",
		}
		if( process.env.REACT_APP_RUNMODE==="PROD" ){
			this.api_url = "https://goisagi.retro-ink.com/beeapi/collie/v1/";
		} else if( process.env.REACT_APP_RUNMODE==="DEV" ){
			this.api_url = "http://localhost:8080/beeapi/collie/v1/";
		} else {
			this.api_url = "http://localhost:8080/beeapi/collie/v1/";
		}
	}

	render() {
		let use_header = true;
		let page;
		if( this.state.mode==="top" ){
			page = TopPage;
			use_header = false;
		} else if( this.state.mode==="intro" ){
			page = IntroPage;
		} else if( this.state.mode==="board" ){
			page = BoardPage;
		} else if( this.state.mode==="badend" ){
			page = BadendPage;
		} else if( this.state.mode==="goodend" ){
			page = GoodendPage;
		} else if( this.state.mode==="result" ){
			page = ResultPage;
		} else {
			page = NotfoundPage;
		}
		const component = React.createElement(
			page,
			{
				setState:(state)=>this.setState(state),
				showLoading:(bool)=>this.showLoading(bool),
				showAlert:(func)=>this.showAlert(func),
				showConfirm:(func1,func2)=>this.showConfirm(func1,func2),
				clearMessage:()=>this.clearMessage(),
				showShadow:(bool)=>this.showShadow(bool),
				addMessage:(mes)=>this.addMessage(mes),
				getUid:()=>this.getUid(),
				getResultKey:()=>this.getResultKey(),
				getPlay:()=>this.getPlay(),
				goTop:()=>this.goTop(),
				//getName:()=>this.getName(),
				//setName:(name)=>this.setName(name),
				setData:(data)=>this.setData(data),
				save:()=>this.save(),
				load:()=>this.load(),
				//isAuth:()=>this.isAuth(),
				openBook:()=>this.openModal("book"),
				openModal:(page,func)=>this.openModal(page,func),
				ajax:(path,data,func)=>this.ajax(path,data,func),
			},
			null
		)

		let shadowclass = "hide";
		if( this.state.isShadow ){
			shadowclass = "shadow_fadein";
		}
		return (
			<div id="main">
				{use_header &&
				<Header
					setState={(data)=>this.setState(data)}
					openBook={()=>this.openModal("book")}
					clearMessage={()=>this.clearMessage()}
					addMessage={(mes)=>this.addMessage(mes)}
					showConfirm={(func1,func2)=>this.showConfirm(func1,func2)}
					goTop={()=>this.goTop()}
					/>
				}
				{component}
				{this.state.isLoading ?(
				<Loading />
				):null}
				<AlertPage
					message={this.state.alertMessage}
					isOpen={this.state.isOpenAlert}
					isConfirm={this.state.isConfirm}
					close={(bool)=>{
						this.setState({isOpenAlert:false});
						if( this.afterAlert ){
							this.afterAlert();
						}
						if( bool && this.afterConfirmYes ){
							this.afterConfirmYes();
						}
						if( !bool && this.afterConfirmNo ){
							this.afterConfirmNo();
						}
					}}
				/>
				<div id="shadow" className={shadowclass}></div>

				<ToastContainer
					position="top-center"
					autoClose={2000}
					hideProgressBar
					closeOnClick
					draggable
				/>
				<ModalPage
					page={this.state.modal_page}
					isOpen={this.state.isOpenModal}
					data={this.data}
					close={()=>{
						if( this.afterModal ){
							this.afterModal();
						}
						this.setState({isOpenModal:false});
					}}
				/>

			</div>
		);
	}
	getUid(){
		if( this.play ){
			if( this.play.uid ){
				return this.play.uid;
			}
		}
		if( this.uid ){
			return this.uid;
		}
		return null;
	}
	getResultKey(){
		if( this.state.result_key ){
			return this.state.result_key;
		}
		return null;
	}
	getPlay(){
		if( this.state.play ){
			return this.state.play;
		}
		return null;
	}
	getName(){
		return this.user_name;
	}
	setName(name){
		this.user_name = name;
	}
	setData(data){
		this.data = data;
	}
	save(){
		const json = {
			"uid": this.state.play.uid,
		};
		window.localStorage.setItem(this.storage_key,JSON.stringify(json));
	}
	load(){
		if( window.localStorage.getItem(this.storage_key) ){
			const json = JSON.parse(window.localStorage.getItem(this.storage_key));
			return json.uid;
		}
		return null;
	}
	goTop (){
		this.setState({mode:'top',result_key:null,play:null,data:[]});
	}
	showLoading(bool){
		this.setState({isLoading:bool});
	}
	addMessage(mes){
		this.messages.push(mes);
	}
	clearMessage(){
		this.messages = [];
	}
	showShadow(bool){
		this.setState({isShadow:bool});
	}
	showAlert(func=null){
		const mes = this.messages.join(",");
		this.afterConfirmYes = null;
		this.afterConfirmNo = null;
		this.afterAlert = null;
		if( func ){
			this.afterAlert = func;
		}
		this.setState({isOpenAlert:true,alertMessage:mes,isConfirm:false});
	}
	showConfirm(func_yes=null,func_no=null){
		const mes = this.messages.join(",");
		this.afterConfirmYes = null;
		this.afterConfirmNo = null;
		this.afterAlert = null;
		if( func_yes ){
			this.afterConfirmYes = func_yes;
		}
		if( func_no ){
			this.afterConfirmNo = func_no;
		}
		this.setState({isOpenAlert:true,alertMessage:mes,isConfirm:true});
	}
	openModal(page,func=null){
		this.afterModal = func;
		this.setState({
			isOpenModal:true,
			modal_page:page,
		});
	}
	ajax( path , data , func ){
		const headers = new Headers()
		headers.append("Content-Type", 'application/json')
			
		// CORS（クロスドメイン通信）を使う場合かつCookie等をリクエストに含める場合
		//const corsOptions = { mode:'cors', credentials:'include' }
		const corsOptions = {}
			
		var options = { headers }
		options = { ...corsOptions, method:'POST',body:JSON.stringify( data ) };

		//console.log( this.api_url+path );
		//console.log( options );

		fetch(this.api_url+path, options).then( res=> {
			//console.log("then1");
			//console.log( res );
			try{
				if( res.status===200 ){
					return res.json();
				} else {
					this.error();
				}
			} catch(err) {
				this.error();
			}
		}).then( (json)=>{
			//console.log("then2");
			//console.log( json );
			func( json );
		}).catch( (err)=>{
			//console.log("catch");
			//console.log(err);
			this.error();
		})
	}
	error(){
		console.log("error");
	}
}

export default MainPage;